import React from "react";
import { useIsDesktop } from "@/hooks/useMediaQuery";
import { StockAlertsPageDesktop } from "./StockAlertsPage.Desktop";
import { StockAlertsPageMobile } from "./StockAlertsPage.Mobile";

export const StockAlertsPage: React.FC = () => {
  const isDesktop = useIsDesktop();
  if (isDesktop) return <StockAlertsPageDesktop />;
  return <StockAlertsPageMobile />;
};
